import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cab63eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-hidden": "true" }
const _hoisted_2 = { class: "delivery-option mb-x2" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-y-x3 sm:gap-x-x4 sm:gap-y-x4" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "w-100" }

import CheckoutSkeletonLine from '@/b2c/shared/checkout/ui/CheckoutSkeletonLine.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickUpDeliverableSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(CheckoutSkeletonLine, { class: "mb-x1 sm:w-150" }),
        _createVNode(CheckoutSkeletonLine, { class: "sm:w-50 mb-x3 sm:mb-x4" }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(CheckoutSkeletonLine, { class: "mb-x1" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-x1" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-x1" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-x1" })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(CheckoutSkeletonLine, { class: "mb-x1" })
            ]),
            _createVNode(CheckoutSkeletonLine)
          ])
        ])
      ])
    ])
  ]))
}
}

})